import * as yup from 'yup';

const campMarketingSchema = yup.object().shape({
  isNovelty: yup.bool(),
  name: yup.string().required('common.required'),
  sport: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
  type: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
  duration: yup.number().required('common.required'),
  startDay: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
  format: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
  features: yup.array().of(yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  })).min(1, 'common.minOne'),
  tags: yup.array().of(yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  })).min(1, 'common.minOne'),
  mainImageMedia: yup.object().shape({
    id: yup.string(),
    fileId: yup.string(),
  }).nullable().required('common.required'),
  sliderImageMedias: yup.array().of(yup.object().shape({
    id: yup.string(),
    fileId: yup.string(),
  })).nullable().min(3, 'common.minThree'),
});

export default campMarketingSchema;
